import { Spin } from "antd";

export const LoadingSpinner = (
  <div className="w-screen h-screen flex justify-center items-center">
    <Spin size="large" />
  </div>
);
